<template>
  <div class="ai-suggestions" aria-label="Suggestions">
    <button
      v-for="item in suggestions"
      :key="item.tag_id"
      type="button"
      :class="{ 'is-selected': selectedTags.includes(item.tag_name) }"
      :disabled="selectedTags.includes(item.tag_name)"
      @click="$emit('toggle-tag', item.tag_name)"
    >
      {{ item.tag_name ? '#'+item.tag_name : '' }}
    </button>
  </div>
</template>

<script setup lang="ts">
import type { SuggestionOption } from '@/tools/tag_hits_api';

defineProps<{
  suggestions: SuggestionOption[];
  selectedTags: string[];
}>();

defineEmits<{
  'toggle-tag': [value: string];
}>();
</script>

<style scoped lang="scss">
.ai-suggestions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px 8px;
  width: min(950px, 100%);
  margin: 20px auto 5vh;

  button {
    min-width: 92px;
    height: 42px;
    padding: 0 24px;
    border: 1px solid #fff;
    border-radius: 999px;
    color: #555;
    background: rgba(255, 255, 255, .62);
    cursor: pointer;
    transition: .2s ease;
    animation: suggestion-float 3s ease-in-out infinite;

    &:nth-child(2) { animation-delay: .3s; }
    &:nth-child(3) { animation-delay: .6s; }
    &:nth-child(4) { animation-delay: .9s; }
    &:nth-child(5) { animation-delay: 1.2s; }
    &:nth-child(6) { animation-delay: .15s; }
    &:nth-child(7) { animation-delay: .45s; }
    &:nth-child(8) { animation-delay: .75s; }
    &:nth-child(9) { animation-delay: 1.05s; }
    &:nth-child(10) { animation-delay: 1.35s; }

    &.is-selected {
      border: 1px solid #58bd6e;
      border-radius: 50px;
      color: #58bd6e;
      background: rgba(245, 252, 255, .6);
      font-family: Roboto-Blod;
      font-size: 15px;
      cursor: default;
    }
  }
}

@media (hover: hover) {
  .ai-suggestions button:not(:disabled):hover {
    border-color: rgba(88, 189, 110, .5);
    color: var(--green);
    background: #fff;
  }
}

@keyframes suggestion-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}

@media (prefers-reduced-motion: reduce) {
  .ai-suggestions button { animation: none; }
}

@media (max-width: 600px) {
  .ai-suggestions {
    gap: 7px;

    button {
      min-width: 0;
      height: 36px;
      padding: 0 14px;
      font-size: 13px;
    }
  }
}
</style>
